import React from 'react';

import Home from './containers/home';
import About from './containers/about';
import './App.css';
import Contact from './containers/contact';
import Footer from './containers/footer';
import Navbar from "./components/navbar"
import Courses from './containers/courses';
import Social from "./containers/social"

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Linkprops
} from "react-router-dom";
import EachCourse from './components/EachCourse';

function App() {
  return (
    <div className="App">
      <Router>
        <Navbar />

        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/about" component={About} />
          <Route path="/contact" component={Contact} />
          <Route path="/courses" exact component={Courses} />
          <Route path="/courses/:name" component={Courses} />
        </Switch>
      </Router>
      <div id="copyrights">
        Hassan Quran Academy
        <br />
        All rights reserved
        &copy; Copyright 2020
      </div>
      {/* <Footer /> */}
      <Social />
    </div >
  );
}

export default App;